import React from 'react';
import { QuestionRendererProps } from './QuestionRenderer';

const DatePickerRenderer: React.FC<Omit<QuestionRendererProps, 'questionNumber'>> = ({
  question,
  value,
  onChange,
  error,
}) => {
  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    onChange(e.target.value);
  };

  return (
    <input
      type="date"
      value={value || ''}
      onChange={handleChange}
      className={`w-full px-4 py-3 border rounded-lg transition-colors ${
        error
          ? 'border-red-300 focus:border-red-500 focus:ring-red-500'
          : 'border-gray-300 focus:border-blue-500 focus:ring-blue-500'
      } focus:outline-none focus:ring-2`}
      aria-invalid={!!error}
      aria-describedby={error ? `${question.id}-error` : undefined}
    />
  );
};

export default DatePickerRenderer;
